import { Badge, Tooltip } from '@mantine/core';
import { IconCircleFilled } from '@tabler/icons-react';

export function TestTag({
  label,
  selected = true,
  disabled,
}: {
  label: string;
  selected?: boolean;
  disabled?: boolean;
}) {
  return (
    <Tooltip
      disabled={disabled}
      label={label}
    >
      <Badge
        className="cursor-pointer text-ellipsis bg-[#EAEAEA] font-semibold normal-case dark:bg-[#4D4D4D]"
        classNames={{
          root: `pl-[3px] ${selected ? 'opacity-100' : 'opacity-50'}`,
          label: `dark:text-[#D9D9D9] text-[#686868]`,
        }}
        leftSection={
          <IconCircleFilled
            color="#B3B3B3"
            size={13}
          />
        }
        variant="filled"
      >
        {label}
      </Badge>
    </Tooltip>
  );
}
